import { ClaimMarketRewardsObjective } from '@/features/actions/flavours/claim-market-rewards/types'
import { MarketInfo } from '@/features/sparklend/common/data/market-info/marketInfo'

export function createClaimMarketRewardsObjectives(marketInfo: MarketInfo): ClaimMarketRewardsObjective[] {
  return marketInfo.userRewards.map((reward) => ({
    assets: reward.assets,
    incentiveControllerAddress: reward.incentiveControllerAddress,
    token: reward.token,
    type: 'claimMarketRewards',
  }))
}
